import { useNavigate } from "react-router-dom"
import "../Css/HomePage.css"

export default function HomePage() {
  const navigate = useNavigate()

  return (
    <div className="home-page">
      <header className="header">
        <div className="container">
          <div className="logo">CloudPriv</div>
          <nav className="nav">
            <ul>
              <li>
                <a href="#features">Características</a>
              </li>
              <li>
                <a href="#pricing">Precios</a>
              </li>
              <li>
                <a href="#about">Nosotros</a>
              </li>
              <li>
                <a href="#contact">Contacto</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <h1>Tu nube empresarial privada</h1>
              <p className="subtitle">Cambiando la forma de trabajar</p>
              <div className="cta-buttons">
                <button className="btn btn-primary" onClick={() => navigate("/test")}>
                  Comenzar ahora
                </button>
                <button className="btn btn-secondary" onClick={() => window.open("https://youtu.be/i-YdFpxB8rI?t=96", "_blank")}>
                  Ver demo
                </button>
              </div>
            </div>
            <div className="hero-image">
              <div className="cloud-graphic"></div>
            </div>
          </div>
        </section>

        <section className="features" id="features">
          <div className="container">
            <h2>Características principales</h2>
            <div className="feature-grid">
              <div className="feature-card">
                <div className="feature-icon security-icon"></div>
                <h3>Seguridad avanzada</h3>
                <p>Protección de datos de nivel empresarial con cifrado de extremo a extremo.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon storage-icon"></div>
                <h3>Almacenamiento flexible</h3>
                <p>Escala según tus necesidades con almacenamiento ilimitado.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon collab-icon"></div>
                <h3>Colaboración en tiempo real</h3>
                <p>Trabaja con tu equipo en documentos y proyectos simultáneamente.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon access-icon"></div>
                <h3>Acceso desde cualquier lugar</h3>
                <p>Conecta con tu nube desde cualquier dispositivo y ubicación.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <div className="container">
            <h2>Lleva tu empresa al siguiente nivel</h2>
            <p>Únete a cientos de empresas que ya confían en nuestra plataforma</p>
            <button className="btn btn-primary" onClick={() => navigate("/app")}>
              Cambiar página
            </button>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">CloudPriv</div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Producto</h4>
                <ul>
                  <li>
                    <a href="#features">Características</a>
                  </li>
                  <li>
                    <a href="#pricing">Precios</a>
                  </li>
                  <li>
                    <a href="#security">Seguridad</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Empresa</h4>
                <ul>
                  <li>
                    <a href="#about">Sobre nosotros</a>
                  </li>
                  <li>
                    <a href="#clients">Clientes</a>
                  </li>
                  <li>
                    <a href="#contact">Contacto</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Recursos</h4>
                <ul>
                  <li>
                    <a href="#docs">Documentación</a>
                  </li>
                  <li>
                    <a href="#blog">Blog</a>
                  </li>
                  <li>
                    <a href="#support">Soporte</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 CloudPriv. Todos los derechos no reservados kieee.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}
